
import React, { Component } from 'react'
import Upload from './upload';
import {connect} from 'react-redux';
import Status from '~/components/pages/MyAccount/BidVerfiy/component/status';
import mapDispatch from '~/misc/mapDispatch';
import css from './UploadW9Anon.css'
import { uploadInfoFromEmailByAnon, uploadW9formByEmail, getW9fromInfoByEmail} from '~/modules/user/actions';
class UploadW9Anon extends Component {
  constructor() {
    super()
    this.state = {
      status: 'active',
      token: ''
    }
  }
  componentDidMount() {
    const query = new URLSearchParams(window.location.search);
    const token = query.get('EmailTokenAnon');
    this.setState({
      token,
    })
    const { getW9fromInfoByEmail } = this.props;
    getW9fromInfoByEmail({token}).then(res=>{
      const { data } = res;
      if(['UPDATE','NEW'].includes(data)) {
        return this.setState({
          status: 'pending'
        })
      }
      if(['VERIFIED'].includes(data)) {
        return this.setState({
          status: 'verified'
        })
      }
    })
  }
  uploadImg = (file) => {
    const { token } = this.state;
    const { uploadImg } = this.props;
    return uploadImg({
      token,
      file,
    })
  }
  uploadInfo = (pics) => {
    const { token } = this.state;
    const { uploadInfo } = this.props;
    const files = {
      ...pics
    }
    return uploadInfo({
      token,
      files,
    }).then( res=> {
      const { code , message } = res;
      if(code!== 200) return;
      this.setState({
        status: 'pending'
      })
    } )
  } 
  render() {
    const { status } = this.state;
    if(status === 'pending') {
      return (
        <div className={css.warp}>
          <Status
            type="pending"
          />
        </div>
      )
    }
    if(status === 'verified') {
      return (
        <div className={css.warp}>
          <Status
            type="success"
          />
        </div>
      )
    }
    return (
      <div className={css.warp}>
        <div className={css.secordTitle}>Upload Documents</div>
        <div className={css.descContent}>
          To join our carrier network, please upload the following documents below. By providing these documents, it will allow us to help you onboard with our partnered brokers/shippers whenever is needed.
        </div>
        <Upload
          uploadImg = {this.uploadImg}
          uploadInfo = {this.uploadInfo}
        />
      </div>
      
    )
  }
}


export default connect(() => ({})
, mapDispatch({
  uploadImg: (props, {token, file}) => uploadW9formByEmail(token, file),
  uploadInfo: (props, {token, files}) => uploadInfoFromEmailByAnon (token, files),
  getW9fromInfoByEmail: (props, {token}) => getW9fromInfoByEmail(token)
}))(UploadW9Anon);



// WEBPACK FOOTER //
// ./src/components/pages/UploadW9Anon/index.js